import { post, get } from "./Service";
import { arrayToMap } from "./../components/Util";
import axios from "axios";

export const getJSON = (payload, onDone) => {
    post("/api/lego/recipe", payload, (res) => {
        onDone(res.data);
    });
};

export const instrument_connection = (payload, onDone) => {
    post("/api/lego/instrument-connection", payload, (res) => {
        onDone(res);
    });
};

export const instrument_ftp_connection = (payload, onDone) => {
    post("/api/lego/machine-connection", payload, (res) => {
        onDone(res);
    });
};

export const fetch_intrument_data = (onDone) => {
    get("/api/lego/fetch-intrument-data", (response) => {
        onDone(response);
    });
};

export const executeQuery = (payload, onDone) => {
    post("/api/lego/query", payload, (res) => {
        if (res && res.status === "SUCCESS") {
            let obj = { data: res.data.result, tabs: res.data.result_tab };
            onDone(obj);
        } else if (res && res.status === "ERROR") {
            let obj = { data: [], tabs: [], error: res.msg };
            onDone(obj);
        } else {
            let obj = { data: [], tabs: [] };
            onDone(obj);
        }
    });
};

export const executedashQuery = (payload, onDone) => {
    post("/api/lego/dashquery", payload, (res) => {
        if (res && res.status === "SUCCESS") {
            let obj = { data: res.data.result, tabs: res.data.result_tab };
            onDone(obj);
        } else if (res && res.status === "ERROR") {
            let obj = { data: [], tabs: [], error: res.msg };
            onDone(obj);
        } else {
            let obj = { data: [], tabs: [] };
            onDone(obj);
        }
    });
};

export const setObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/set-object", payload, (res) => {
        onDone(res);
    });
};

export const approveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-object", payload, (res) => {
        onDone(res);
    });
};

export const approveSample = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-sample", payload, (res) => {
        onDone(res);
    });
};
export const approveTesting = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-testing", payload, (res) => {
        onDone(res);
    });
};

export const approveExperiment = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-experiment", payload, (res) => {
        onDone(res);
    });
};


export const approveSection = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/approve-section", payload, (res) => {
        onDone(res);
    });
};

export const dispatchEmail = (payload, onDone) => {
    post("/api/lego/dispatch-email", payload, (res) => {
        onDone(res);
    });
};

export const investigate = (payload, onDone) => {
    post("/api/lego/investigation-flow", payload, (res) => {
        onDone(res);
    });
};
export const testinginvestigate = (payload, onDone) => {
    post("/api/lego/testing-investigation-flow", payload, (res) => {
        onDone(res);
    });
};

export const getSetObject = (payload, onDone) => {
    post("/api/lego/upsert", payload, (res) => {
        onDone(res);
    });
};

export const getNextSequence = (payload, onDone) => {
    post("/api/lego/next-sequence", payload, (res) => {
        onDone(res);
    });
};

export const getLookups = (module_name, operation_type, operation_name, payload, onDone) => {
    post(`/api/lego/${module_name}/${operation_type}/${operation_name}`, payload, (res) => {
        if (res && res["Result Set"]) {
            let lookup = res["Result Set"];
            lookup = arrayToMap(lookup, 'family');
            onDone(lookup);
        }
    });
};

export const consignObject = (payload, onDone) => {
    post("/api/lego/consign-object", payload, (res) => {
        onDone(res);
    });
};

export const addTask = (payload, onDone) => {
    post("/api/lego/add-task", payload, (res) => {
        onDone(res);
    });
};

export const deleteAlert = (payload, onDone) => {
    post("/api/lego/delete-alert", payload, (res) => {
        onDone(res);
    });
};

export const deleteTask = (payload, onDone) => {
    post("/api/lego/delete-task", payload, (res) => {
        onDone(res);
    });
};

export const fields_remarks = (payload, onDone) => {
    post("/api/lego/fields-remarks", payload, (res) => {
        onDone(res);
    });
};
export const section_audit = (payload, onDone) => {
    post("/api/lego/section_audit", payload, (res) => {
        onDone(res);
    });
};

export const results_fields_remarks = (payload, onDone) => {
    post("/api/lego/results-fields-remarks", payload, (res) => {
        onDone(res);
    });
};
export const coa_remarks = (payload, onDone) => {
    post("/api/lego/coa-remarks", payload, (res) => {
        onDone(res);
    });
};
export const placeholder_remarks = (payload, onDone) => {
    post("/api/lego/placeholder_remarks", payload, (res) => {
        onDone(res);
    });
};
export const get_oauth_config = (payload, onDone) => {
    post("/api/security/auth/oauth2/config", payload, (res) => {
        onDone(res);
    });
};
export const insert_user_info = (payload, onDone) => {
    post("/api/lego/insert_user_info", payload, (res) => {
        onDone(res);
    });
}
export const uploadfile_server = (payload, onDone) => {
    post("/api/lego/uploadfile_server", payload, (res) => {
        onDone(res);
    });
};
export const server_configuration = (payload, onDone) => {
    post("/api/lego/server_configuration", payload, (res) => {
        onDone(res);
    });
};
export const browse_server_connect = (payload, onDone) => {
    post("/api/lego/browse_server_connect", payload, (res) => {
        onDone(res);
    });
};
export const sample_fields_remarks = (payload, onDone)=>{
    post("/api/lego/sample-fields-remarks",payload,(res)=>{
        onDone(res);
    })
};




export const qmssetObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/qms-set-object", payload, (res) => {
        onDone(res);
    });
};

export const qmsapproveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/qms-approve-object", payload, (res) => {
        onDone(res);
    });
};

export const qmsworkflowObject = (payload, onDone) => {
    payload.is_email_send = payload.is_email_send ? payload.is_email_send : false;
    post("/api/lego/qms-workflow-object", payload, (res) => {
        onDone(res);
    });
};

export const qmsworkflowapproveObject = (payload, onDone) => {
    let site_id = JSON.parse(sessionStorage.getItem('user')).current_auth.site_id;
    payload.site_id = payload.site_id ? payload.site_id : site_id;
    post("/api/lego/qms-workflow-approve-object", payload, (res) => {
        onDone(res);
    });
};
export const createEventReport = (payload, onDone) => {
    console.log("payload", payload);
    post("/api/lego/qms_event_report", payload, (res) => {
        onDone(res);
    });
};

export const ServerConnection = (onDone, onError) => {
  let resolved = false;
  const timeoutId = setTimeout(() => {
    if (!resolved) {
      resolved = true;
      console.warn("Server connection failed due to timeout.");
      onDone({ online: false, message: "Server connection failed due to timeout." });
    }
  }, 3000);
  get("/api/security/health",(response) => {
      if (!resolved) {
        resolved = true;
        clearTimeout(timeoutId);
        onDone(response);
      }
    },
    (error) => {
      if (!resolved) {
        resolved = true;
        clearTimeout(timeoutId);
        if (onError) onError(error);
      }
    }
  );
};

export const fetchServerTime = async () => {
  try {
    const response = await axios.get('/api/security/server-time'); 
    return response.data.serverTime;  // Assuming serverTime is in ISO string format
  } catch (error) {
    console.error('Error fetching server time:', error);
    return null;
  }};